function GroupFormCtrl($scope, $timeout, $state, $controller, GeneralUtilsService){
    $controller('ConfigController', {$scope: $scope, $timeout: $timeout});

    $scope.groupId = $state.params.groupId;
    $scope.importType = $state.params.importType;
    $scope.hideGroupTable = !!($scope.groupId);
    $scope.itemsdatamodified = false;
    $scope.dnssettingsdatamodified = false;
    $scope.datamodified = false;
    $scope.selectedItems = null;
    $scope.proxyFileConfigProperties={};

    $scope.removeGroupilters = function(){
        $scope.groupId = null;
        $scope.importType = null;
        $state.go('app.groups', {
            groupId: null,
            importType: null
        });
    };


    $scope.$root.hasChanges = function(){
        if(!$scope.group) {
            return false;
        }
        if($scope.group.id < 0) {
            return true;
        } //new group

        var hasProxyFileConfigChanged = false;
        if($scope.proxyFileConfigProperties.hasChanges){
            hasProxyFileConfigChanged = $scope.proxyFileConfigProperties.hasChanges();
        }

        if (hasProxyFileConfigChanged) return true;

        var hasChangesInGroup = !angular.equals($scope.group, $scope.orig);

        if ($scope.group.importType == 'LDAP' || $scope.group.importType == 'SCIM') {
            // allow changes in settings (but not in members)
            if (hasChangesInGroup) {
                return !(($scope.group.itemsToAdd && $scope.group.itemsToAdd.length > 0) || ($scope.group.itemsToDelete && $scope.group.itemsToDelete.length > 0));
            } else {
                return false;
            }

        } else {
            return hasChangesInGroup;
        }



    };

    $scope.showItem = 'general';


    // config for the group names table on the left
    $scope.tableConfig = {
        hasChanges: $scope.$root.hasChanges,
        noAutoCheckboxSelect: true,
        mode: 'list',
        importNames:{"LDAP":"LDAP","REGULAR":"Manual","SYSTEM":"System","SCIM":"SCIM"},
        accountId : $state.params.accountId,
        dataURL : function(){
            var groupIdParam = $scope.groupId ? "&gid=" + $scope.groupId : "";
            var importTypeParam = $scope.importType ? "&importType=" + $scope.importType : "";
            var accountSpecificSysGroupParam = "&customSystemGroups=True";
            return "/groups?accountId=" + $state.params.accountId + groupIdParam + importTypeParam + accountSpecificSysGroupParam;
        },
        titleSearch: 'Groups',
        height: $scope.getContentHeight(),
        pageSize: 50,
        sortButton: true,
        processData: function(items){
            items.forEach(function(item) {
                if (item.prefix) item.caption = item.prefix + item.name;
            });
        },
        afterUpdate: function(){
            if($scope.$root){
                $scope.$root.updateScroll('.pane.left .nano');
            }
        },
        unselectable: function(group) {
            return group.overridingSystemGroupId;
        },
        searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
        showTable: false,
        fields : [{"label":"Name","path":"groupName","template":"<span>{{item.prefix}}{{item.groupName}}</span>"},
            {"label":"Description","path":"description","template":"<span>{{item.description}}</span>"},
            {"label":"Origin","path":"importType","template":"<span>{{item.importType == 'LDAP'?'LDAP defined': (item.importType == 'SYSTEM'? 'System Group' : 'User defined')}}</span>"},
            {"label":"Creation Date","path":"creationDate"},
            {"label":"Last Modified","path":"lastModified"}
        ],
        type : "Group",
        addAction : function(){
            $scope.newGroup = {id:GeneralUtilsService.getRandomId(),"name":""};
            $scope.$root.openPopup('addGroupDlg');
        },
        actions: ["remove"],
        onSelect : function(index) {
            $timeout(function() {
                clearSelections();
                $scope.$root.clearErrors();
                $scope.group = $scope.tableConfig.items[index];
                $scope.group.dhcpSettings = $scope.group.dhcpSettings || [];
                $scope.orig = angular.copy($scope.group);
                $scope.proxyFileConfigProperties.entity = $scope.group;
                $scope.proxyFileConfigProperties.orig = $scope.orig;
                $scope.itemsdatamodified = new Date().getTime();
                $scope.dnssettingsdatamodified = new Date().getTime();
                disableGroupActions();
                $scope.updateRightScroll();

				$scope.$broadcast('modelReloadedEvent', {model: $scope.group});
            }, 0);
        }
    };



    /**
      * set selected items in the configuration according to the
      * given items array
    **/
    function updateConfigSelectedItems(config,items){
        config.selectedItems = [];
        items.forEach(function(configItem){
            if($scope.selectedItems[configItem.id]){
                config.selectedItems.push(configItem);
            }
        });
    }

    /**
      * clear all selections from the configurations
    **/
    function clearSelections(){
        $scope.hostConfig.selectedItems = [];
        $scope.loginsConfig.selectedItems = [];
        $scope.sitesConfig.selectedItems = [];
        $scope.iprangesConfig.selectedItems = [];
        $scope.floatingIpsConfig.selectedItems = [];
        $scope.dsUserConfig.selectedItems = [];

        if ($scope.group) {
            $scope.group.dhcpSettings = $scope.orig.dhcpSettings;
            delete $scope.group.itemsOperation;
        }
    }
    /**
      * fill the selected items array according to the items
      * given
    **/
    function fillSelectedItems(items){
        $scope.selectedItems = {};
        if(items){
            items.forEach(function(item){
                    $scope.selectedItems[item.id] = item.name;
            });
        }
    }

    $scope.itemsConfig = {
        dataURL : function(){
            if(!$scope.group || $scope.group.id < 0){
                return null;
            }
            else {
                var groupParam = "groupId=" + $scope.group.id ;
                if($scope.group.importType == 'SYSTEM'){
                    groupParam = 'systemgroupId=' + $scope.group.overridingSystemGroupId;
                }
                return "/groupItems?accountId=" + $state.params.accountId+ "&" +groupParam + "&importType=" + $scope.group.importType;
            }
        },
        getData : function() {
            if($scope.group && $scope.group.id > 0){
                return null;
            }
            else {
                return {"items":[]}
            }
        },
        processData: function(items){
            loadSelectedItems4GroupMembers(items);
            setDisplayTypes(items);
            filterClientSideDeletedItems(items);
        },
        titleSearch: "Members",
        defer:true,
        showTable: false,
        fields : [
            {"label":"Type", "template":"<span>&nbsp;{{item.displayType | capitalize}}</span>", noSort: true},
            {"label":"Name","path":"name","template":"<span>{{item.display_name ? item.display_name : item.name}}</span>"}
        ],
        actions:[],
        specialActions : [
            {'icon':'add','tooltip':'Add','id':'addButton','func' :
                function(selectedItems,config) {
                    $scope.$root.openPopup('addItemsToGroup');
                    if (!$scope.showAddItem) {
                        $scope.showAddItem = 'site';
                    }
                }
            },
            {'icon':'delete','tooltip':'Delete','func' :
                function(selectedItems,config) {
                    $scope.group.itemsOperation = {"add":{"sites":[],"logins":[], "users":[], "ipranges":[],"hosts":[], "networkinterfaces": [], "nativeRanges": [], "floatingIps" :[]},"remove":{"sites":[],"logins":[],"users":[], "ipranges":[],"hosts":[], "networkinterfaces": [], "nativeRanges": [], "floatingIps" :[]}};
                    selectedItems.forEach(function(item) {
                        var collection = getCollectionFromType(item.type.toLowerCase());
                        $scope.group.itemsOperation["remove"][collection].push(item);
                        deleteSelectedItem(item.id,item.type);
                    });
                    for(var i = $scope.itemsConfig.items.length - 1 ; i >= 0 ; i--) {
                        var found = false;
                        selectedItems.forEach(function(selectedItem) {
                            if(!found && $scope.itemsConfig.items[i].id == selectedItem.id){
                                $scope.itemsConfig.items.splice(i,1);
                                found = true;
                            }
                        });
                    }
                    $scope.updateRightScroll();
                }
            }
        ]
    };

    /**
     * The deletion from this table is on client side, but pagination is on server side.
     * This method clears out client side deleted items when user moves between pages.
     */
    function filterClientSideDeletedItems(items) {
        if (!$scope?.group?.itemsOperation) {
            return
        }

        if (items && items.length) {
            let i = 0;
            while (i < items.length) {
                const item = items[i];
                const collection = getCollectionFromType(item.type.toLowerCase());
                if ($scope.group.itemsOperation.remove[collection].find(el => el.id === item.id && el.type === item.type)) {
                    items.splice(i, 1);
                } else {
                    ++i;
                }
            }
        }
    }

    /**
      * setting display type for the given items
    **/
    function setDisplayTypes(items){
        items.forEach(function(item){
            setDisplayType(item);
        });
    }

    function setDisplayType(item){
        switch (item.type) {
            case 'HOSTSUBNET':
                item.displayType = 'host';
                break;
            case 'SUBNET':
                item.displayType = 'native range';
                break;
            case 'ACCESSLOGIN':
                item.displayType = 'VPN user';
                break;
            case 'DIRECTORYSERVICEUSER':
                item.displayType = 'directory service User';
                break;
            case 'INTERFACEIPRANGE':
                item.displayType = 'IP Range';
                break;
            case 'NETWORKINTERFACE':
                item.displayType = 'Network Interface';
                break;
            default:
                item.displayType = item.type;
                break;
        }
    }

    /**
      * loads for each config the selected items according to
      * to the items found in the group members table
      *
    **/
    function loadSelectedItems4GroupMembers(items){
        //  refill the selected items array
        fillSelectedItems(items);

        var configs = {};
        var configsInPopup = [];
        items.forEach(function(item){
            var type = item.type;
            if(!configs[type]){
                configs[type] = getConfigByType(type);
                if (configsInPopup.indexOf(getConfigByType(type)) < 0)
                    configs[type].selectedItems = [];
                configsInPopup.push(getConfigByType(type));
            }
            configs[type].selectedItems.push(item);
        });
    }

    /**
      * remove item from the selected items array and
      * from the configuration associated with this items type
    **/
    function deleteSelectedItem(id,type){
        delete $scope.selectedItems[id];
        var newSelectedItems = [];
        var config = getConfigByType(type);
        config.selectedItems.forEach(function(item){
            if(item.id != id){
                newSelectedItems.push(item);
            }
         });
        config.selectedItems = newSelectedItems;
    }

    /**
      * returns the configuration for the given type
    **/
    function getConfigByType(type){
        return (type.toLowerCase() == "site"? $scope.sitesConfig :(type.toLowerCase() == 'accesslogin' ?
         $scope.loginsConfig:(type.toLowerCase() == 'hostsubnet' ? $scope.hostConfig : (type.toLowerCase() =='directoryserviceuser' ? $scope.dsUserConfig :( type.toLowerCase() == 'floatingipsubnet' ? $scope.floatingIpsConfig : $scope.iprangesConfig)))));
    }


    $scope.sitesConfig = {
        titleSearch: true,
        fixedLayout: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/sites?accountId=" + $state.params.accountId;
        },
        showTable: false,
        fields : [{"label":"Name","path":"name","template":"{{item.name}}"},
            {"label":"Address","path":"address","template":"<span>{{item.address}}</span>"}
        ],
        processData: function(items){
        },
        type : "Site",
        actions: [],
        selectedItems:[],
        pageSize:5
    };

    $scope.loginsConfig = {
        titleSearch: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/logins?accountId=" + $state.params.accountId;
        },
        fields : [{"label":"Name","path":"name","template":"{{item.name}}"},
            {"label":"E-mail","path":"email"}
        ],
        processData: function(items){
        },
        type : "AccessLogin",
        actions: [],
								searchFields: ['email'],
        selectedItems:[],
        pageSize:5
    };

    $scope.iprangesConfig = {
        titleSearch: true,
        fixedLayout: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/getNetworks?isRequestFromOFE=1&accountId=" + $state.params.accountId;
        },
        fields : [
            {label: 'Name', path: 'name', template: '<span>{{item.name}}</span>'},
            {"label":"Site","path":"siteName","template":"<span>{{item.siteName}}</span>"},
            {"label":"Interface","path":"interfaceName","template":"<span>{{item.interfaceName}}</span>"},
            {"label":"Type","path":"type","template":"<span>{{item.type | capitalize}}</span>"},
            {"label":"Range","path":"subnet","template":"<span>{{item.subnet}}</span>"}
        ],
        processData: function(items){
        },
        type : "IPRange",
        actions: [],
        selectedItems:[],
        pageSize:5
    };

       $scope.floatingIpsConfig = {
            titleSearch: true,
            fixedLayout: true,
            accountId: $state.params.accountId,
            method: 'GET',
            dataURL : function(){
                return "/getFloatingIps?accountId=" + $state.params.accountId;
            },
            fields : [
                {label: 'Name', path: 'floatingRangeName', template: '<span>{{item.floatingRangeName}}</span>'},
                {label:"IP Range","path":"subnet",template:"<span>{{item.subnet}}</span>"}],
            processData: function(items){
            },
            type : "floatingips",
            actions: [],
            selectedItems:[],
            pageSize:5,
            clientSidePaging: true,
            clientSideSearch: true,
            clientSideSort: true
        };


    $scope.hostConfig = {
        titleSearch: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/subnets?accountId=" + $state.params.accountId;
        },
        fields : [
            {"label":"Name","path":"name","template":"<span>{{item.name}}</span>"},
            {"label":"Site","name":"siteName","template":"<span>{{item.siteName}}</span>"},
            {"label":"Network","path":"interfaceName","template":"<span>{{item.interfaceName}} <span ng-if='item.range'> \\ {{item.range}}</span></span>"},
            {"label":"IP","path":"subnet","template":"<span>{{item.translatedSubnet}}</span>"}
        ],
        processData: function(items){
        },
        type : "Host",
        actions: [],
        selectedItems:[],
        pageSize:5

    };

    $scope.dsUserConfig = {
        titleSearch: true,
        accountId: $state.params.accountId,
        dataURL : function(){
            return "/getAllDsUsers?accountId=" + $state.params.accountId;
        },
        fields : [{"label":"Name","path":"Login Name","template":"<span>{{item.loginName}}</span>"},
                    {"label":"Subnet","path":"Full Name","template":"<span>{{item.fullName}}</span>"}
                ],
        processData: function(items){
        },
        type : "DsUser",
        actions: [],
        selectedItems:[],
        pageSize:5

    };

    $scope.saveChanges = function(){

        // System groups are saved on a special way
        var savePath = $scope.group.importType === "SYSTEM"? "/editSystemGroup" : "/edit";
        var queryParams = $scope.group.importType === "SYSTEM"?
            {'accountId':$state.params.accountId,'save':true, 'systemgroupId': $scope.group.overridingSystemGroupId, "fields": "['dnsSettings','dhcpSettings', 'proxyConfigurationFile']"} :
            {'groupId':$scope.group.id,'save':true};


        $scope.group.newSaveMethod = true;
        $scope.loading = true;
        store.save({
            path: savePath,
            data: $scope.group,
            dataObj: 'json',
            queryParams: queryParams,
            success: function(data) {
                $scope.loading = false;
                $scope.$root.handleServerResponse(data,"group", "Group saved successfully");
                if(data.status !== "ERROR"){
                    $scope.group = data.model;
                    $scope.orig = angular.copy($scope.group);
                    $scope.proxyFileConfigProperties.entity = $scope.group;
                    $scope.proxyFileConfigProperties.orig = $scope.orig;
                    $scope.itemsdatamodified = new Date().getTime();
                    $scope.dnssettingsdatamodified = new Date().getTime();
                    // after successful change unmark changed rows
                    $scope.itemsConfig.selectedItems = [];


				    $scope.$broadcast('modelReloadedEvent', {model: $scope.group});
                }
            }
        });
    };

    $scope.addGroup = function(){
        $scope.loadingSaveNew = true;
        store.save({
            path: "/add",
            data: $scope.newGroup,
            dataObj: 'json',
            queryParams: {'accountId': $state.params.accountId,'type':'group','save':true},
            success: function(data) {
                $scope.loadingSaveNew = false;
                $scope.$root.handleServerResponse(data,"newGroup", "Group saved successfully");
                if(data.status !== "ERROR"){
                    $scope.tableConfig.selectedId = data.model.id;
                    $scope.datamodified = new Date().getTime();
                    $scope.$root.closePopup('addGroupDlg');
                }
            }
        });
    };

    $scope.addItems = function(){
        if (!$scope.group) {
            $timeout(function() {
                $scope.addItems();
            }, 10, false);
        }

        if(!$scope.group.itemsToAdd){
            $scope.group.itemsToAdd = [];
        }
        $scope.group.itemsOperation = {"add":{"sites":[],"logins":[], "ipranges":[],"hosts":[],"users":[], "networkinterfaces": [], "nativeRanges" :[], "floatingIps" :[]},"remove":{"sites":[],"logins":[], "ipranges":[],"users":[], "networkinterfaces": [], "nativeRanges":[], "floatingIps" :[]}};
        addIfNotExising($scope.sitesConfig.selectedItems,'SITE');
        addIfNotExising($scope.loginsConfig.selectedItems,'ACCESSLOGIN');
        addIfNotExising($scope.iprangesConfig.selectedItems,'INTERFACEIPRANGE');
        addIfNotExising($scope.iprangesConfig.selectedItems,'SUBNET');
        addIfNotExising($scope.iprangesConfig.selectedItems,'NETWORKINTERFACE');
        addIfNotExising($scope.hostConfig.selectedItems,'HOSTSUBNET');
        addIfNotExising($scope.dsUserConfig.selectedItems,'DIRECTORYSERVICEUSER');
        addIfNotExising(updateFloatingIpsDisplayName($scope.floatingIpsConfig.selectedItems),'FLOATINGIPSUBNET');
        $scope.$root.closePopup('addItemsToGroup');
        $scope.updateRightScroll();
    };


    function updateFloatingIpsDisplayName(items){
        if(items){
         items.forEach(function(item){
               if(item.type == 'FLOATINGIPSUBNET'){
                  item.display_name = item.floatingRangeName;
            }
        });

        return items;
        }
    }

    function getCollectionFromType(type) {
        switch (type.toLowerCase()) {
            case 'site':
                return 'sites';
            case 'subnet' :
                return 'nativeRanges';
            case 'hostsubnet':
                return 'hosts';
            case 'accesslogin':
                return 'logins';
            case 'directoryserviceuser':
                return 'users';
            case 'interfaceiprange':
                return 'ipranges';
            case 'networkinterface':
                return 'networkinterfaces';
            case 'floatingipsubnet':
                return 'floatingIps';
        }
    }

    function addIfNotExising(arr,type){
        var collection = getCollectionFromType(type);

        arr.forEach(function(newItem) {
            if (newItem.type === type) {
                var found = false;

                $scope.itemsConfig.items.forEach(function(item) {
                    if(item.type == type && item.id == newItem.id) {
                        found = true;
                    }
                });
                if(!found){
                   /* if (newItem.display_name) {
                        newItem.name = newItem.display_name;
                    }*/
                    // set the display type for the new item in items config
                    setDisplayType(newItem);
                    $scope.itemsConfig.items.push(newItem);
                    $scope.group.itemsToAdd.push(newItem);
                    $scope.group.itemsOperation["add"][collection].push(newItem);
                }
            }

        });

        var itemsToRemove =[];
        $scope.itemsConfig.items.forEach(function (item) {
            // item was unchecked
            if(getType(item) ==type  && arr.indexOf(item)== -1){
                if(!$scope.group.itemsOperation["remove"][collection])
                    $scope.group.itemsOperation["remove"][collection]=[];
                $scope.group.itemsOperation["remove"][collection].push(item);
                itemsToRemove.push(item);
            }
        });

        //remove items
        itemsToRemove.forEach(function (item) {
            $scope.itemsConfig.items.splice($scope.itemsConfig.items.indexOf(item),1);
        })
    }

    /**
     * return the type from the items
     * @param item
     * @returns {string}
     */
    function getType(item) {
//        if(item.type=='SUBNET'){
//            return "HOSTSUBNET";
//        }
//        else{
            return item.type;
//        }
    }

    function disableGroupActions(){
        $scope.itemsConfig.actionsDisabled = ($scope.group.importType == 'LDAP' || $scope.group.importType == 'SYSTEM' || $scope.group.importType == 'SCIM');
    }
}
